import React, { useEffect } from 'react'

export default function MobileResults({ gridData, setDetailsSelection, toggleActiveItem, setSelectedParcel, selectedParcel }) {


    useEffect(() => {
        if (gridData.length === 1) {
            setSelectedParcel(gridData[0]);
        }
    }, [gridData])

    const fields = [{
        label: "Site Address",
        value: selectedParcel?.SiteAddress || "NA"
    }, {
        label: "Site Address City",
        value: selectedParcel?.SiteCity || ""
    }, {
        label: "Township",
        value: selectedParcel?.Township || ""
    }, {
        label: "Owner",
        value: selectedParcel?.Owner || ""
    }, {
        label: "Tax Code",
        value: selectedParcel?.TaxCode || ""
    }, {
        label: "Tax Status",
        value: selectedParcel?.TaxStatus || ""
    }, {
        label: "Property Class",
        value: selectedParcel?.PropertyClass || ""
    }, {
        label: "Mail to Address",
        value: selectedParcel?.MailToAddress1 || ""
    }, {
        label: "Mail to City",
        value: selectedParcel?.MailToCity || ""
    }, {
        label: "Parcel Area",
        value: selectedParcel?.ParcelArea || ""
    }]


    return (
        <div className="text-xs text-bold m-0 p-0">
            {selectedParcel ? (
                <>
                    <div className='border border-gray-700 rounded-md p-2 text-lg'>
                        <h3 className="font-bold">Parcel: {selectedParcel?.ParcelNumber}</h3>
                        <hr className="my-1 border-gray-700" />
                        {fields.map((field, i) => {
                            return (
                                <div key={i} className="flex items-center justify-between">
                                    <span className='text-gray-600'>{field.label}</span>
                                    <span>{field.value}</span>
                                </div>
                            )
                        })}
                    </div>
                    <button className="border border-gray-700 rounded-md p-2 text-lg w-full mt-4 font-bold flex items-center justify-between" onClick={() => {
                        setDetailsSelection(selectedParcel);
                        toggleActiveItem("results");
                    }}><span>Show Details</span> <span><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="#010cb6" fillRule="evenodd" d="M9.97 7.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L13.44 12L9.97 8.53a.75.75 0 0 1 0-1.06" clipRule="evenodd"></path></svg></span></button>
                </>
            ) :
                <ul>
                    {gridData.map((row, i) => {
                        return (
                            <li onClick={() => {
                                setSelectedParcel(row);
                            }} key={i} className="flex items-center justify-between btn btn-sm">
                                <span>Parcel: {row.ParcelNumber}</span><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><path fill="#010cb6" fillRule="evenodd" d="M9.97 7.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L13.44 12L9.97 8.53a.75.75 0 0 1 0-1.06" clipRule="evenodd"></path></svg>
                            </li>
                        );
                    })}
                </ul>
            }
        </div>
    )
}